import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac1543e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumb-item" }
const _hoisted_2 = { key: 2 }

import { reactive } from 'vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBreadcrumbItem',
  props: {
    to: {},
    toNum: {},
    isLastItem: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

/* eslint-disable */


const { to, isLastItem, toNum } = reactive(props);

// 验证只能传递两个属性中的一个
if (to && toNum) {
    throw new Error('组件NavBreadcrumbItem中的属性to和属性toNum只能选择一个！！！');
}


return (_ctx: any,_cache: any) => {
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(to))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "click-span",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(to))))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_unref(toNum))
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "click-span",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).go(_unref(toNum))))
          }, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])),
    (!_unref(isLastItem))
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 3,
          style: {"margin":"0 2px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowRight)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})